export const environment = "prod"
export const host="https://api.pintaredu.id/"
export const host_http="http://82.29.160.140:3040/"
export const debug = true
export const hostFEV2 = "https://siswa.pintaredu.id"
export const hostAdminFEV2 = "https://pengajar.pintaredu.id"
export const enableSSO = true